import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const emailApi = createApi({
  reducerPath: "emailApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["email"],
  endpoints: (builder) => ({
    sendEmailLink: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.emailController.sendEmailLink}${body.emailId}`,
          method: "POST",
          body: body.payload,
        };
      },
    }),
  }),
});

export const { useSendEmailLinkMutation } = emailApi;
